import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: null,
  loading: false,
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const inventoryDashboardSlice = createSlice({
  name: 'inventoryDashboard',
  initialState,
  reducers: {
    setInventoryItems(state, action) {
      state.items = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

export const inventoryDashboardActions = inventoryDashboardSlice.actions;
export default inventoryDashboardSlice.reducer;
